import { ExcelIcon, WordDocIcon } from "../../packages/SVGs";

/**
 * Creates download menu items configuration for Excel and Word reports
 * @param {Function} t - Translation function
 * @param {boolean} isDataAvailable - Whether data is available for download
 * @param {boolean} isLoading - Whether the page is in loading state
 * @param {Function} handleExcelExport - Excel export handler
 * @param {Function} handleWordDownload - Word download handler
 * @returns {Array} Array of menu item configurations
 */
export const createDownloadMenuItems = (
  t,
  isDataAvailable,
  isLoading,
  handleExcelExport,
  handleWordDownload
) => [
  {
    id: "Excel Report",
    label: (
      <>
        <ExcelIcon />
        {t("predictionStrings.excelReport")}
      </>
    ),
    isDisabled: !isDataAvailable || isLoading,
    onClick: handleExcelExport,
  },
  {
    id: "Word Report",
    label: (
      <>
        <WordDocIcon />
        {t("predictionStrings.wordReport")}
      </>
    ),
    isDisabled: !isDataAvailable || isLoading,
    onClick: handleWordDownload,
  },
];
